/**
 * This class overrides some of the EDD provided checkout functionality
 */
class CustomEDD {

    constructor() {
    }

    init() {

        const self  = this;
        const $     = jQuery;

        /*
         * for handling custom validations
         */
        self.formValidations();

        /*
         * for handling Applying of Discount Code
         */
        $('#edd-discount-code-wrap').find('.edd-apply-discount').on('click', function (e) {
            e.preventDefault();
            self.apply_discount(e);
        });

        /*
         * for handling Removing of Discount Code
         */
        $('#edd_remove_discount').on('click', function (e) {
            e.preventDefault();
            self.remove_discount(e);
        });

        /*
         * for handling 'Purchase' which will process checkout
         */
        $('#edd_purchase_form #edd_purchase_submit_alt [type=submit]').on('click', function (e) {
            self.process_payment(e);
        });

        /*
         * for handling 'Add to Cart'
         */
        $('.edd_purchase_submit_wrapper .edd-add-to-cart').on('click', function(e) {
            e.preventDefault();
            $('.edd_purchase_submit_wrapper').css({ 'opacity': 0 });
            $(this).css({'display': 'none'});
            setTimeout(() => {
                $('.edd_purchase_submit_wrapper .edd_go_to_checkout').css({ 'display': 'inline-grid' });
                $('.edd_purchase_submit_wrapper').css({ 'opacity': 1 });
            }, 1000);
        });

        /*
         * for handling Dynamic Membership Products to Cart
         */
        self.add_membership_to_cart();

    } // init

    apply_discount( event ) {

        const self  = this;
        const $     = jQuery;

        const discount_code = $('#edd-discount').val(),
            edd_discount_loader = $('#edd-discount-loader'),
            required_inputs = $( '#edd_cc_address .edd-input, #edd_cc_address .edd-select' ).filter( '[required]' );

        if ( discount_code == '' || discount_code == edd_global_vars.enter_discount ) {
            return false;
        }

        const postData = { action: 'edd_apply_discount', code: discount_code, form: $('#edd_purchase_form').serialize() };

        $( '#edd-discount-error-wrap' ).html( '' ).hide();
        edd_discount_loader.show();

        $.ajax( {
            type: 'POST',
            data: postData,
            dataType: 'json',
            url: edd_global_vars.ajaxurl,
            xhrFields: {
                withCredentials: true,
            },
            success: function( discount_response ) {
                if (discount_response) {

                    if (discount_response.msg == 'valid') {
                        // simply reload the page
                        const parser = new URL(window.location);
                        parser.searchParams.set('discount', 'applied');
                        window.location = parser.href;
                    } else {
                        $( '#edd-discount-error-wrap' ).html( '<span class="edd_error">' + discount_response.msg + '</span>' );
                        $( '#edd-discount-error-wrap' ).show();
                    }
                } else {
                    if ( window.console && window.console.log ) {
                        // console.log( discount_response );
                    }
                    $( document.body ).trigger( 'edd_discount_failed', [ discount_response ] );
                }
                edd_discount_loader.hide();
            },
        } ).fail( function( data ) {
            if ( window.console && window.console.log ) {
                $( '#edd-discount-error-wrap' ).html( data.status + ' ' + data.statusText ).show();
            }
        } );
        return false;
    }

    remove_discount(event) {

        const self = this;
        const $ = jQuery;

        const postData = {
            action: 'edd_remove_discount',
            code: $(event.target).data( 'code' ),
        };

        $.ajax( {
            type: 'POST',
            data: postData,
            dataType: 'json',
            url: edd_global_vars.ajaxurl,
            xhrFields: {
                withCredentials: true,
            },
            success: function (discount_response) {
                // simply reload the page
                const { code, discounts, html, total, total_plain } = discount_response;
                const results = discounts.find(element => { return element == code });
                if (html === null) {
                    const parser = new URL(window.location);
                    parser.searchParams.delete('discount');
                    window.location = parser.href;
                }
            },
        } ).fail( function( data ) {
            if ( window.console && window.console.log ) {
                // console.log( data );
            }
        } );

        return false;
    }

    /**
     * This function is based on the "Process checkout" event handler which can be found in edd-ajax.js
     *
     * @see themes/ehrc/helpers/edd/hooks.php ( pl_custom_edd_checkout_form function )
     * @see easy-digital-downloads/assets/js/frontend/edd-ajax.js
     * @param {*} event
     * @returns
     */
    process_payment(event) {

        const self = this;
        const $ = jQuery;
        const target = event.target;

        const eddPurchaseform = document.getElementById('edd_purchase_form');

        // not needed since we are validating from both
        // front end ( for stripe card )
        // backend ( via EDD )
        //
        // if ( typeof eddPurchaseform.checkValidity === 'function' && false === eddPurchaseform.checkValidity() ) {
        //     return;
        // }

        event.preventDefault();

        // let us do some custom validation for Stripe Element
        const valid = self._validationsForCreditCardInfo();
        if ( !valid ) {
            // scroll to the Credit Card Info section
            $('html, body').animate({ scrollTop: $('#edd_cc_fields').offset().top }, 500);
            return;
        }

        // At this point, we have renamed #edd_purchase_submit to #edd_purchase_submit_alt
        // so that the plugin supplied "Process checkout" event handler DOES NOT fire
        //
        const complete_purchase_val = $(target).val();

        // for the custom loading indicator
        this.show_loading(target);

        $( target ).val( edd_global_vars.purchase_loading );
        $( target ).prop( 'disabled', true );
        $( target ).after( '<span class="edd-loading-ajax edd-loading"></span>' );

        $.post(edd_global_vars.ajaxurl, $('#edd_purchase_form').serialize() + '&action=edd_process_checkout&edd_ajax=true', function (data) {

            let response = data; // success, <div class="...">...</div>
            let status;
            let responseIsJson = false;
            let message;
            try {
                response        = JSON.parse(data);
                status          = response.success ?? false;
                responseIsJson  = true;
                const msg       = response.data.message ?? 'Checkout Error';
                message         = $('<div class="edd_errors edd-alert edd-alert-error"><p class="edd_error" id="edd_error_checkout_error"><strong>Checkout Error</strong>: ' +  msg + '</p></div>');
            } catch (e) {
                status          = data; // e.g. success or HTML formatted content
                message         = data;
            }

            if ($.trim(response) === 'success') {

                $( '.edd_errors' ).remove();
                $('.edd-error').hide();

                setTimeout(function() {
                    // NOTE: this in the original callback function causes our payment to POST "too fast"
                    // before all the necessary stripe information is fed back to the form submission
                    // which causes this error: "Error: Unable to locate Payment Method"
                    //
                    // (depreacted) Since it already seems to 'auto' submit without needing to call .submit(), we are disabling this
                    // which is the whole point of generating a custom form submission event to process payment
                    //
                    // (Nov15, 2024) Adding this back in, because now it needs to be here - issue reported by client
                    // in Asana: https://app.asana.com/0/41564792581470/1208768759137356/f
                    //
                    $(eddPurchaseform).submit();
                }, 150);

            } else {

                self.hide_loading(target);

                $( '#edd-purchase-button' ).val( complete_purchase_val );
                $( '.edd-loading-ajax' ).remove();
                $( '.edd_errors' ).remove();
                $('.edd-error').hide();

                $( edd_global_vars.checkout_error_anchor + '_alt' ).before( message );
                $( '#edd-purchase-button' ).prop( 'disabled', false );

                $( document.body ).trigger( 'edd_checkout_error', [ message ] );
            }
        });

    }

    add_membership_to_cart() {

        const self  = this;
        const $     = jQuery;

        const membership_options = $('.membership_options'); if ( membership_options.length == 0 ) return;
        const primary = $(membership_options).find('.primary-option'); if (primary.length == 0 ) return;

        function reset_primary() {
            $(primary).val('');
        }

        function reset_membership_selection() {
            $('.membership_options .controls a').addClass('disabled')
                .attr('href', 'javascript:void()');

            // go through and reset
            $('.membership_options select.variations').addClass('disabled')
                .css({ display: 'none' })
                .find('option:first-child').attr('selected', true);

            $('.membership_options .controls .price-container')
                .css({ 'display': 'none' })
                .find('.membership-price').html('');

            $('.membership_options .generic-form-group.variations').css({ display: 'none' });
        }

        function allow_add_to_cart( selected ) {

            $(membership_options)
                .find('.controls #add-product-to-cart')
                .attr('href', selected.data('t'))
                .removeClass('disabled');

            $(membership_options)
                .find('.controls #reset-selections')
                .removeClass('disabled')
                .on('click', function(e) {
                    e.preventDefault();
                    reset_primary();
                    reset_membership_selection();
                });

            // Display the Price
            $(membership_options)
                .find('.controls .price-container')
                .css({ 'display': 'block' })
                .find('.membership-price').html( selected.data('amount') );
        }

        // on load
        reset_membership_selection();

        $(primary).on('change', function(e) {
            const selected_value    = $(this).val();
            let option              = ''; reset_membership_selection();
            if ( selected_value != '' ) {
                option = $(this).find(":selected");
                const select_to_show = $(membership_options).find( '#' + option.data('target') );

                // Show the Active One
                $(select_to_show).css({ display: 'block' });
                $(select_to_show).closest('.generic-form-group.variations').css({ display: 'block' });

                // based on the selection, we need to get the TARGET
                let add_to_cart = '';
                const selected_variation = $(select_to_show).find(':selected');

                // add_to_cart = selected_variation.data('t'); // the URL
                // we have no 'blank' value so we need to directly adjust the add_to_cart URL
                allow_add_to_cart( selected_variation );
                $(select_to_show).on('change', function(evt) {
                    // add_to_cart = $(this).find(':selected').data('t');
                    allow_add_to_cart(  $(this).find(':selected') );
                });
           }
        });

    }

    // for the custom loading indicator
    show_loading( target ) {
        jQuery( target ).parent().parent().addClass('is-loading');
    }
    hide_loading( target ) {
        jQuery( target ).parent().parent().removeClass('is-loading');
    }

    /**
     * main entry that calls various Validation Workarounds
     */
    formValidations() {
        const self = this;
        self._validationsForCheckoutLogin();
        self._validationsForCheckoutForm();
    }

    _validationsForCheckoutLogin() {
        const self          = this;
        const $             = jQuery;
        const loginForm     = $('#edd_checkout_login_register'); if ( loginForm.length == 0 ) return;
        const observer      = new MutationObserver(function(mutationList, observer) {
            mutationList.forEach(function(mutation) {
                if ( mutation.type === 'childList' ) {
                    mutation.addedNodes.forEach(function(addedNode) {
                        if ( addedNode.classList.contains('has-validation-issues') ) {
                            addedNode.classList.forEach(function(className, idx) {
                                if ( /validation-error/.test(className) ) {
                                    const field = className.replace('validation-error_', '');
                                    const input = $(loginForm).find('#' + field);
                                    const container = input.parent();
                                    container.addClass('gfield_error');
                                    // input.focus();
                                }
                            });
                        }
                    });
                }
            });
        });
        observer.observe(loginForm[0], { childList: true, subtree: true  });
    }

    _validationsForCreditCardInfo() {

        const self          = this;
        const $             = jQuery;

        let passed          = 0;
        const totalValid    = 4;

        // let us run some custom validations on Stripe Element fields
        const cardName= $('#edd-card-name-wrap #card_name');
        if ( cardName.val() === '' ) {
            cardName.parent().addClass('gfield_error');
        } else {
            cardName.parent().removeClass('gfield_error');
            passed++;
        }

        const cardNumber = $('#edd-stripe-card-element');
        if ( cardNumber.hasClass('StripeElement--empty') ) {
            cardNumber.closest('#edd-card-wrap').addClass('gfield_error');
        } else {
            cardNumber.closest('#edd-card-wrap').removeClass('gfield_error');
            passed++;
        }

        const cardExp = $('#edd-stripe-card-exp-element');
        if ( cardExp.hasClass('StripeElement--empty') ) {
            cardExp.closest('#edd-card-exp-wrap').addClass('gfield_error');
        } else {
            cardExp.closest('#edd-card-exp-wrap').removeClass('gfield_error');
            passed++;
        }

        const cardCCV = $('#edd-stripe-card-cvc-element');
        if ( cardCCV.hasClass('StripeElement--empty') ) {
            cardCCV.closest('#edd-card-cvv-wrap').addClass('gfield_error');
        } else {
            cardCCV.closest('#edd-card-cvv-wrap').removeClass('gfield_error');
            passed++;
        }

        return (passed == totalValid) ? true : false;

    }

    _validationsForCheckoutForm() {

        const self          = this;
        const $             = jQuery;
        const checkoutForm  = $('#edd_purchase_form'); if ( checkoutForm.length == 0 ) return;

        const observer      = new MutationObserver(function(mutationList, observer) {
            mutationList.forEach(function(mutation) {
                if ( mutation.type === 'childList' ) {
                    mutation.addedNodes.forEach(function(addedNode) {

                        if ( !addedNode.hasOwnProperty('classList') ) {
                            return;
                        }

                        if ( addedNode.classList.contains('has-validation-issues') ) {
                            addedNode.classList.forEach(function(className, idx) {
                                if ( /validation-error/.test(className) ) {
                                    const field = className.replace('validation-error_', '');
                                    const input = $(checkoutForm).find('#' + field);
                                    const container = input.parent();
                                    container.addClass('gfield_error');
                                    // input.focus();
                                    // $('html, body').animate({ scrollTop: container.offset().top }, 500);
                                }
                            });
                        }
                    });
                }
            });
        });
        observer.observe(checkoutForm[0], { childList: true, subtree: true  });
    }

} // class CustomEDD

export default CustomEDD;
